import type { Uuid } from "@/domains/global/identifiers";

/**
 * Selection state for a section of notes
 */
export enum SectionSelectionState {
  All = "all",
  None = "none",
  Indeterminate = "indeterminate",
}

/**
 * Represents a note available for import
 */
export interface ImportableNote {
  id: Uuid;
  title: string;
  markdown: string;
  /**
   * Source folder path (e.g., from Apple Notes nested folders).
   * Example: ["Work", "Mem", "Auto Organize"] represents Work -> Mem -> Auto Organize.
   * The last folder is used for section grouping, all folders become collections.
   */
  folders: string[];
  isSelected: boolean;
  isLocked: boolean;
  lockedReason?: string;
  isPinned: boolean;
  createdAt?: string;
  updatedAt?: string;
  subtitle?: string;
  tags: string[];
}

/**
 * Import status for tracking the one-click import process
 */
export enum ImportStatus {
  Idle = "idle",
  InProgress = "in_progress",
  Success = "success",
  Failed = "failed",
}

/**
 * Loading status for fetching notes from Apple Notes
 */
export enum LoadingStatus {
  Loading = "loading",
  Done = "done",
  Error = "error",
}
